/**
 * Aliases de Componentes - Vuetify
 *
 * Componentes virtuales con variantes predefinidas para uso frecuente
 */

import { VBtn } from 'vuetify/components/VBtn'
import { VCard } from 'vuetify/components/VCard'

export const aliases = {
  // Botones con variantes predefinidas
  VBtnPrimary: VBtn,
  VBtnSecondary: VBtn,
  VBtnTertiary: VBtn,
  VBtnSuccess: VBtn,
  VBtnDanger: VBtn,
  VBtnWarning: VBtn,
  VBtnInfo: VBtn,

  // Cards con variantes predefinidas
  VCardElevated: VCard,
  VCardOutlined: VCard,
  VCardFlat: VCard,
}
